var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xcard"},[_c('h3',{staticClass:"text-center text-primary"},[_vm._v("Registro de docentes")]),_c('p',{staticClass:"text-center"},[_vm._v("Complete el siguiente formulario con los datos del docente para registralo en el sistema portal.")]),_c('a-reg-docentes')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }